import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap , tap, withLatestFrom, mergeMap} from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';

import * as AuthActions from '../store/actions/auth.action';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import {select, Store} from '@ngrx/store';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as citiesActions from '../../cities/store/actions/cities.action';
import * as chatActions from '../../chat/store/actions/chat.action';


@Injectable()
export class AuthEffects {

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.login),
      withLatestFrom(this.store.pipe(select((state: any)  => state.auth))),
      mergeMap(([action, authState]) => {
        const { username, password } = authState;
          // Call your authentication service method
          return this.authService.login({username, password}).pipe(
            map(user => {
              this.router.navigate(['/orders-create']);
              this.store.dispatch(citiesActions.getCities());
              return AuthActions.loginSuccess({ user });
            }),
            catchError(error => {
              console.error('Error occurred:', error);
              this.snackBar.open(
                'Usuario o contraseña inválidos. Por favor verifica tus datos e intenta nuevamente',
                'Cerrar',
                {
                  duration: 3000
                }
              );
              return of(AuthActions.loginFail({ error }));
            })
          );
      })
    )
  );


logout$ = createEffect(() =>
  this.actions$.pipe(
    ofType(AuthActions.logout),
    tap(() => this.authService.logout())
  ),
  { dispatch: false }
);



  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private router: Router,
    private snackBar: MatSnackBar,
    private store: Store,
  ) {}
}
